import React from 'react';
import {
  ShimmerButton,
  ShimmerCard,
  ShimmerTable,
  ShimmerText,
  ShimmerThumbnail,
  ShimmerTitle
} from '../../../assets/shimmer';

const ViewprojectShimmer = () => {
  return (
    <ShimmerCard className="py-4 shimmer-code px-4" style={{ boxShadow: 'none' }}>
      <div className="d-flex gap-1">
        <ShimmerTitle line={1} style={{ width: '100px' }}></ShimmerTitle>
        <ShimmerTitle line={1} style={{ width: '100px' }}></ShimmerTitle>
        <ShimmerTitle line={1} style={{ width: '100px' }}></ShimmerTitle>
        <ShimmerTitle line={1} style={{ width: '100px' }}></ShimmerTitle>
        <ShimmerTitle line={1} style={{ width: '100px' }}></ShimmerTitle>
      </div>
      <ShimmerText line={10} />
    </ShimmerCard>
  );
};
const DatabaseShimmer = () => {
  return (
    <ShimmerCard className="py-4 shimmer-code" style={{ boxShadow: 'none' }}>
      <div className="d-flex justify-content-between align-items-center gap-1 px-4">
        <ShimmerThumbnail className="rounded-2" style={{ height: '40px', width: '200px' }} />
        <ShimmerButton size="sm" className="rounded-2"></ShimmerButton>
      </div>
      <ShimmerCard className="px-2 pb-3 mt-2" style={{ boxShadow: 'none' }}>
        <ShimmerTable col={3} row={8}></ShimmerTable>
      </ShimmerCard>
    </ShimmerCard>
  );
};
const TeamMemberShimmer = () => {
  return (
    <ShimmerCard className="py-4 shimmer-code team-member" style={{ boxShadow: 'none' }}>
      <div className="d-flex flex-column flex-md-row align-items-center gap-1 px-4">
        <ShimmerThumbnail className="rounded-2" style={{ height: '40px', width: '200px' }} />
        <ShimmerThumbnail className="rounded-2" style={{ height: '40px', width: '200px' }} />
      </div>
      <ShimmerCard className="px-2 pb-3 mt-2" style={{ boxShadow: 'none' }}>
        <ShimmerTable col={3} row={8}></ShimmerTable>
      </ShimmerCard>
    </ShimmerCard>
  );
};
const TaskStatusShimmer = () => {
  return (
    <ShimmerCard className="py-4 shimmer-code task-status" style={{ boxShadow: 'none' }}>
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-1 px-4">
        <ShimmerThumbnail className="rounded-2" style={{ height: '40px', width: '200px' }} />
        <ShimmerButton size="md" className="rounded-2" style={{ width: '200px' }}></ShimmerButton>
      </div>
      <ShimmerCard className="px-2 pb-3 mt-2" style={{ boxShadow: 'none' }}>
        <ShimmerTable col={4} row={8}></ShimmerTable>
      </ShimmerCard>
    </ShimmerCard>
  );
};
const SpintShimmer = () => {
  return (
    <ShimmerCard className="py-4 shimmer-code" style={{ boxShadow: 'none' }}>
      <div className="d-flex justify-content-between align-items-center gap-1 px-4 sprints">
        <ShimmerThumbnail className="rounded-2" style={{ height: '40px', width: '200px' }} />
        <ShimmerButton size="md" className="rounded-2"></ShimmerButton>
      </div>
      <ShimmerCard className="px-2 pb-3 mt-2" style={{ boxShadow: 'none' }}>
        <ShimmerTable col={5} row={8}></ShimmerTable>
      </ShimmerCard>
    </ShimmerCard>
  );
};
const TaskListViewShimmer = () => {
  return (
    <ShimmerCard className="py-4 pt-0 mt-2 px-3 shimmer-code" style={{ boxShadow: 'none' }}>
      <div className="d-flex flex-column px-1 align-items-center gap-2">
        <ShimmerThumbnail className="rounded-2 mb-0" style={{ height: '40px', width: '100%' }} />
        <ShimmerThumbnail className="rounded-2 mb-0" style={{ height: '40px', width: '100%' }} />
        <ShimmerThumbnail className="rounded-2 mb-0" style={{ height: '40px', width: '100%' }} />
        <ShimmerThumbnail className="rounded-2 mb-0" style={{ height: '40px', width: '100%' }} />
        <ShimmerThumbnail className="rounded-2 mb-0" style={{ height: '40px', width: '100%' }} />
        <ShimmerThumbnail className="rounded-2 mb-0" style={{ height: '40px', width: '100%' }} />
        <ShimmerThumbnail className="rounded-2 mb-0" style={{ height: '40px', width: '100%' }} />
        <ShimmerThumbnail className="rounded-2 mb-0" style={{ height: '40px', width: '100%' }} />
      </div>
    </ShimmerCard>
  );
};
const TaskBoardViewShimmer = () => {
  return (
    <ShimmerCard className="py-4 pt-0 mt-2 px-3 shimmer-code " style={{ boxShadow: 'none' }}>
      <div className="d-flex px-1 justify-content-between board-shimmer" style={{ height: '60vh' }}>
        <ShimmerThumbnail className="rounded-2 mb-0" style={{ height: '100%', width: '15.55%' }} />
        <ShimmerThumbnail className="rounded-2 mb-0" style={{ height: '100%', width: '15.55%' }} />
        <ShimmerThumbnail className="rounded-2 mb-0" style={{ height: '100%', width: '15.55%' }} />
        <ShimmerThumbnail
          className="rounded-2 mb-0 last3"
          style={{ height: '100%', width: '15.55%' }}
        />
        <ShimmerThumbnail
          className="rounded-2 mb-0 last2"
          style={{ height: '100%', width: '15.55%' }}
        />
        <ShimmerThumbnail
          className="rounded-2 mb-0 last"
          style={{ height: '100%', width: '15.55%' }}
        />
      </div>
    </ShimmerCard>
  );
};
const DatabaseTableShimmer = () => {
  return (
    <ShimmerCard className="py-4 shimmer-code" style={{ boxShadow: 'none' }}>
      <div className="d-flex justify-content-between align-items-center gap-1 px-4">
        <ShimmerTitle line={1} style={{ width: '30%' }}></ShimmerTitle>
        <ShimmerButton size="md" className="rounded-2"></ShimmerButton>
      </div>
      <div className="d-flex align-items-center px-4 dbTable" style={{ gap: '15px' }}>
        <ShimmerThumbnail className="rounded-2" style={{ height: '40px', width: '200px' }} />
        <ShimmerThumbnail className="rounded-2" style={{ height: '40px', width: '100px' }} />
        <ShimmerThumbnail className="rounded-2" style={{ height: '40px', width: '150px' }} />
        <ShimmerThumbnail className="rounded-2" style={{ height: '40px', width: '100px' }} />
      </div>
      <ShimmerCard className="px-2 pb-3 mt-2" style={{ boxShadow: 'none' }}>
        <ShimmerTable col={5} row={8}></ShimmerTable>
      </ShimmerCard>
    </ShimmerCard>
  );
};

export default ViewprojectShimmer;
export {
  DatabaseShimmer,
  TeamMemberShimmer,
  TaskStatusShimmer,
  SpintShimmer,
  TaskListViewShimmer,
  TaskBoardViewShimmer,
  DatabaseTableShimmer
};
